import type { OrderDocumentTypeValue } from '@my/tms-api';
import type { SelectInputOption } from '@my/ui';

/** Operator-facing labels for OrderDocumentType. Order matters: POD first (most uploaded). */
export const ORDER_DOCUMENT_TYPE_LABELS: Record<OrderDocumentTypeValue, string> = {
  Pod: 'Proof of delivery',
  Cmr: 'CMR',
  TransportOrder: 'Transport order',
  Invoice: 'Invoice',
  Manifest: 'Manifest',
  CustomsDeclaration: 'Customs declaration',
  Bookings: 'Booking',
  Photo: 'Photo',
  Other: 'Other',
};

export const ORDER_DOCUMENT_TYPE_OPTIONS: SelectInputOption[] = (
  Object.entries(ORDER_DOCUMENT_TYPE_LABELS) as Array<[OrderDocumentTypeValue, string]>
).map(([value, label]) => ({ value, label }));
